
import N64Platform from './n64';

export default [
    new N64Platform(),
];
